export default {
  SECTION: "section",
  CATALOG: "catalog",
  VIEW: "view",
  RECORD: "record"
};
